export const languageStringMap = {
    ar: 'عرض الموقع باللغة العربية',
    de: 'Website auf Deutsch anzeigen',
    en: 'View this site in English',
    es: 'Ver sitio en español',
    fr: 'Afficher le site en français',
    it: 'Visualizza il sito in italiano',
    ja: '日本語でサイトを表示する',
    nl: 'Website in het Nederlands bekijken',
    pl: 'Zmień język na polski',
    pt: 'Visualizar o site em português',
    sv: 'Visa sidan på svenska',
    tr: 'Siteyi Türkçe Görüntüle',
    zh: '查看本网站的中文版本',
};
